<template>
  <v-card>
    <v-container class="d-flex">
      <v-icon class="mr-3">mdi-application-cog</v-icon>
      <h3 v-text="$t('servicesystem.pages.site_settings.layout_options')" class="align-self-center" />
    </v-container>
    <v-divider v-if="!isPhoneBool" />
    <v-card v-if="!isPhoneBool" class="pa-4" elevation="0">
      <v-card class="d-flex flex-wrap justify-space-between" elevation="0">
        <v-card class="background123 preview-nav d-flex justify-center" width="18%"
          :class="[isInverted ? 'order-1' : 'order-0', hover === hoverNavKey ? 'highlight' : '']">
          <v-icon v-if="hover === hoverNavKey" color="white" size="50"
            v-text="isInverted ? 'mdi-arrow-left' : 'mdi-arrow-right'" />
        </v-card>
        <v-card class="d-flex flex-wrap justify-space-between" width="80%" elevation="0">
          <v-card class="background123 preview-header" width="100%">
          </v-card>
          <v-card elevation="0" :width="hover === hoverPreviewKey ? '39%' : '78%'">
            <v-card class="background123 preview-li" width="100%" />
            <v-card class="background123 preview-li" width="100%" />
            <v-card class="background123 preview-li" width="100%" />
            <v-card class="background123 preview-li" width="100%" />
            <v-card class="background123 preview-li" width="100%" />
          </v-card>
          <v-card v-if="hover === hoverPreviewKey" class="background123 d-flex justify-center"
            :class="hover === hoverPreviewKey ? 'highlight' : ''" width="39%">
            <v-icon v-if="hover === hoverPreviewKey" color="white" size="50"
              v-text="false ? 'mdi-close' : 'mdi-plus'" />
          </v-card>
          <v-card class="background123" width="20%">
          </v-card>
        </v-card>
      </v-card>
    </v-card>
    <v-list class="py-0">
      <v-divider v-if="!isPhoneBool" />

      <switch-li v-if="!isPhoneBool" :label="$t('servicesystem.pages.site_settings.inverted_nav_layout')"
        :value="isInverted" :keyname="'InvertedLayout'" :edit="true" @fetch="updateValue"
        @mouseover.native="handleHover(hoverNavKey)" @mouseleave.native="handleHover(false)">
      </switch-li>

      <v-divider v-if="!isPhoneBool" />
      <slider-li v-if="!isPhoneBool" :label="$t('servicesystem.pages.site_settings.nav_width')" v-model="NavMenuWidth"
        :min="250" :max="500" :edit="true" @mouseover.native="handleHover(hoverNavKey)"
        @mouseleave.native="handleHover(false)">
      </slider-li>

      <v-divider />

      <switch-li v-if="isPhoneBool" :label="$t('servicesystem.pages.site_settings.inverted_mobile_routerbtns')"
        :value="isInvertedMobileRouterbtns" :keyname="'InvertedMobileRouterbtns'" :edit="true" @fetch="updateValue">
      </switch-li>

      <v-divider v-if="isPhoneBool" />

    </v-list>
  </v-card>
</template>


<script>
import SliderLi from "@/components/Inputs/SliderListItem.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";

export default {
  name: "LayoutOptionsCard",
  components: { SwitchLi, SliderLi },

  data() {
    return {
      hover: false,
      hoverNavKey: "nav",
      hoverHeaderKey: "header",
      hoverListKey: "list",
      hoverPreviewKey: "preview pane",
      hoverFiltersKey: "filter section",
    };
  },

  mounted() {},

  methods: {
    updateValue(update) {
      this.$store.dispatch("prefrences/set_prefrence", { key: update.key, value: update.value });
      //this.hover = false;
    },
    handleHover(value) {
      this.hover = value;
    },
  },

  computed: {
    isInverted() {
      return this.$store.getters["prefrences/Prefrence"]("InvertedLayout");
    },

    NavMenuWidth: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("NavMenuWidth");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "NavMenuWidth", value: update });
      },
    },

    isInvertedMobileRouterbtns() {
      return this.$store.getters["prefrences/Prefrence"]("InvertedMobileRouterbtns");
    },
  },
};
</script>

<style>
.preview-li {
  height: 18% !important;
  margin-bottom: 2%;
}
.preview-nav {
  height: 200px !important;
}
.preview-header {
  height: 15% !important;
  margin-bottom: 2% !important;
}
.background123 {
  background-color: rgb(139, 145, 158) !important;
  color: white !important;
  height: 80%;
  width: 100%;
  padding: 5px 10px;
}
.background123.highlight {
  background-color: rgb(28, 102, 212) !important;
}
</style>